import React ,{ useContext } from 'react';
// context
import { DrawerContext } from '../contexts/DrawerContext'


export default function useDrawer() {

 const drawerContext = useContext(DrawerContext);

 if (!drawerContext) {
    throw new Error('context outside the provider');
 }
  
 return drawerContext;
}